require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-in-august-2021-the-idbs-board-of-directors-approved.json") })
        }
      }, "path---en-us-update-in-august-2021-the-idbs-board-of-directors-approved");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-in-august-2021-the-idbs-board-of-directors-approved!./.cache/json/en-us-update-in-august-2021-the-idbs-board-of-directors-approved.json
// module id = 757
// module chunks = 231608221292675